import React from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { SkeletonLoader } from '@vio/atlas/SkeletonLoader';
import { OfferLayoutBaseProps, OfferLayoutLoadingProps } from '.';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1bd6lf2",
  propsAsIs: false
});
const LeftWrapper = /*#__PURE__*/styled('div')({
  name: "LeftWrapper",
  class: "l1fcupfx",
  propsAsIs: false
});
const InfoWrapper = /*#__PURE__*/styled('div')({
  name: "InfoWrapper",
  class: "i18k6rhi",
  propsAsIs: false
});
const RightWrapper = /*#__PURE__*/styled('div')({
  name: "RightWrapper",
  class: "r10gjeps",
  propsAsIs: false
});
export const SkeletonWrapper = /*#__PURE__*/styled('div')({
  name: "SkeletonWrapper",
  class: "sc635w0",
  propsAsIs: false
});
export const PrimaryMultiColumnLayout: React.FC<OfferLayoutBaseProps | OfferLayoutLoadingProps> = ({
  isLoading,
  priceComponent,
  cashbackComponent,
  providerLogoComponent,
  ctaComponent,
  roomNameComponent,
  roomLabelsComponent,
  tagComponent,
  dataId
}) => {
  if (isLoading) return <SkeletonWrapper>
        <div>
          <SkeletonLoader width={110} height={30} />
          <SkeletonLoader width={90} height={20} marginTop={4} />
          <SkeletonLoader width={160} height={20} marginTop={4} />
        </div>
        <div>
          <SkeletonLoader width={90} height={40} align="right" />
          <SkeletonLoader width={130} height={42} marginTop={4} align="right" />
        </div>
      </SkeletonWrapper>;
  return <Wrapper data-id={dataId}>
      <LeftWrapper>
        <div>{tagComponent}</div>
        <InfoWrapper className={cx(Boolean(tagComponent) && 'hasPadding')}>
          {providerLogoComponent}
          {roomNameComponent}
          {roomLabelsComponent}
        </InfoWrapper>
      </LeftWrapper>
      <RightWrapper>
        {priceComponent}
        {cashbackComponent}
        {ctaComponent}
      </RightWrapper>
    </Wrapper>;
};

require("./PrimaryMultiColumnLayout.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PrimaryMultiColumnLayout.tsx");